import React, { useEffect, useRef, useState } from "react";
import allImages from "../../assets/images-import";
import ImageSkeleton from "../Common/Loaders/ImageSkeleton";

/**
 * Shared image preview with a loading skeleton + graceful fallback.
 * Purely presentational — used by media cards and the cropper preview.
 */
const MediaPreview = ({ src, alt = "", className = "" }) => {
  const [ready, setReady] = useState(false);
  const [errored, setErrored] = useState(false);
  const imgRef = useRef(null);
  const imageSrc = src && String(src).trim() ? String(src).trim() : "";

  useEffect(() => {
    setReady(false);
    setErrored(false);
  }, [imageSrc]);

  // If the browser already has this URL cached, the native "load" event can
  // fire before the onLoad handler below is attached — the skeleton would
  // then spin forever even though the image is available. Catch that case
  // explicitly once the <img> exists for the current src.
  useEffect(() => {
    if (!imageSrc) return;
    const img = imgRef.current;
    if (img && img.complete) {
      if (img.naturalWidth > 0) {
        setReady(true);
      } else {
        setErrored(true);
        setReady(true);
      }
    }
  }, [imageSrc]);

  if (!imageSrc) {
    return (
      <div className={`xc-ml-preview ${className}`.trim()}>
        <ImageSkeleton width="100%" height="100%" className="xc-ml-preview__skeleton" />
      </div>
    );
  }

  return (
    <div className={`xc-ml-preview ${className}`.trim()}>
      {!ready && !errored ? (
        <ImageSkeleton width="100%" height="100%" className="xc-ml-preview__skeleton" />
      ) : null}
      <img
        ref={imgRef}
        src={imageSrc}
        alt={alt}
        style={{ display: ready || errored ? "block" : "none" }}
        onLoad={() => setReady(true)}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = allImages.DefultImage;
          setErrored(true);
          setReady(true);
        }}
      />
    </div>
  );
};

export default MediaPreview;
